import BrandLogo from './BrandLogo';
import '../css/PosSidebar.css';

/**
 * The top bar: who this screen belongs to, and the way into the menu.
 *
 * The SAME shape as the court-booking system's admin header — brand on the
 * left, one Menu button on the right that opens the drawer. Nothing else lives
 * up here on purpose: the screens below are wide (a product grid, a sales
 * table), and a bar that also carried the nav would start dropping items on a
 * counter tablet exactly when the screen list grew.
 *
 * @param {object} props
 * @param {string} props.title - the club, or '<product> - Admin'.
 * @param {string} [props.logoUrl] - falsy renders BrandLogo's placeholder.
 * @param {() => void} props.onOpenMenu
 * @returns {JSX.Element}
 */
function PosTopBar({ title, logoUrl = '', onOpenMenu }) {
  return (
    <header className="pos-topbar">
      <div className="pos-topbar-brand">
        <BrandLogo src={logoUrl} alt={title} className="pos-topbar-logo" />
        <span className="pos-topbar-title" title={title}>{title}</span>
      </div>

      <button
        type="button"
        className="pos-topbar-menu"
        onClick={onOpenMenu}
        aria-haspopup="menu"
      >
        {/* A text glyph rather than an icon component, per CLAUDE.md > Icons.
            It carries no meaning on its own, so it is hidden from screen
            readers and the word beside it does the work. */}
        <span aria-hidden="true">&#9776;</span> Menu
      </button>
    </header>
  );
}

export default PosTopBar;
